// src/index.js
import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import EstimatorTool from './EstimatorTool';

// Mount point
const container = document.getElementById('root');
const root = createRoot(container);

// Optional: helpful debug in development to confirm env wiring
if (process.env.NODE_ENV === 'development') {
  // CRA injects REACT_APP_* at build time
  // eslint-disable-next-line no-console
  console.log('[ENV] REACT_APP_API_BASE_URL =', process.env.REACT_APP_API_BASE_URL);
}

root.render(
  <React.StrictMode>
    <EstimatorTool />
  </React.StrictMode>
);
